import hasPermission from "@/directive/has-permission";

const importDirective = Vue => {
  Vue.directive('hasPermission', hasPermission)
}

export default importDirective
